import { logout, useGetProfile } from '@sunrise-ui/api-client';
import { Avatar, menuContentStyle, useAuthStore } from '@sunrise-ui/primitives';
import { router } from 'expo-router';
import React, { useState } from 'react';
import { TouchableOpacity } from 'react-native';
import { Menu } from 'react-native-paper';

export function HomeScreenAvatar() {
  const { currentUserId } = useAuthStore();
  const { data: profile } = useGetProfile(currentUserId);
  const [menuVisible, setMenuVisible] = useState(false);

  const handleProfilePress = () => {
    setMenuVisible(false);
    router.navigate('/profile');
  };

  const handleTicketsPress = () => {
    setMenuVisible(false);
    router.navigate('/profile/tickets');
  };

  const handleLogoutPress = async () => {
    setMenuVisible(false);
    await logout();
  };

  return (
    <Menu
      visible={menuVisible}
      contentStyle={menuContentStyle}
      onDismiss={() => setMenuVisible(false)}
      anchor={
        <TouchableOpacity onPress={() => setMenuVisible(true)}>
          <Avatar userId={currentUserId} size="tiny" profile={profile} />
        </TouchableOpacity>
      }
      anchorPosition="bottom"
    >
      <Menu.Item onPress={handleProfilePress} title="My Profile" />
      <Menu.Item onPress={handleTicketsPress} title="Tickets" />
      <Menu.Item onPress={handleLogoutPress} title="Logout" />
    </Menu>
  );
}
